"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuatorResponse$ = exports.ValuatorResponse$outboundSchema = exports.ValuatorResponse$inboundSchema = void 0;
exports.valuatorResponseToJSON = valuatorResponseToJSON;
exports.valuatorResponseFromJSON = valuatorResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const valuatorwrapper_js_1 = require("./valuatorwrapper.js");
/** @internal */
exports.ValuatorResponse$inboundSchema = z.object({
    data: valuatorwrapper_js_1.ValuatorWrapper$inboundSchema,
});
/** @internal */
exports.ValuatorResponse$outboundSchema = z.object({
    data: valuatorwrapper_js_1.ValuatorWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ValuatorResponse$;
(function (ValuatorResponse$) {
    /** @deprecated use `ValuatorResponse$inboundSchema` instead. */
    ValuatorResponse$.inboundSchema = exports.ValuatorResponse$inboundSchema;
    /** @deprecated use `ValuatorResponse$outboundSchema` instead. */
    ValuatorResponse$.outboundSchema = exports.ValuatorResponse$outboundSchema;
})(ValuatorResponse$ || (exports.ValuatorResponse$ = ValuatorResponse$ = {}));
function valuatorResponseToJSON(valuatorResponse) {
    return JSON.stringify(exports.ValuatorResponse$outboundSchema.parse(valuatorResponse));
}
function valuatorResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ValuatorResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ValuatorResponse' from JSON`);
}
//# sourceMappingURL=valuatorresponse.js.map